import { createStyles } from "@material-ui/core";
import theme from "../../theme/default-theme";

export default createStyles({

  loaderContainer: {
    width: "100%",
    height: 700,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  container: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 1200,
    padding: 5,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("md")]: {      
      display: "flex",
      flexDirection: "column",
      flex: 1,
      maxWidth: 1200,
      padding: 25
    }
  },

});
